import { helpbuttonStyle, datePickerStyle, convertToLocalStyle, glyphIconStyle, getBlockerStyle, spinnerKeyframe } from '@bingads-webui-campaign-react/common-styles';
import { creationCommonStyle } from '@bingads-webui-campaign-react/campaign-adgroup-settings-shared-styles';

export const sharedStyles = core =>
  ({
    hotelCampaignBase: {
      padding: '32px 32px 48px 24px',
      minWidth: '1032px',
      backgroundColor: `${core && core.palette && core.palette.neutralLighterAlt}`,
      '& .campaign-title .title': {
        fontSize: '20px',
        fontWeight: '600',
      },
      '& .helpbutton': helpbuttonStyle(core)['.helpbutton'],
      '& .helpbutton::before': helpbuttonStyle(core)['.helpbutton::before'],
      ...convertToLocalStyle(glyphIconStyle(core)),
      ...creationCommonStyle(core),
      '& .dashline': {
        borderBottom: `1px solid ${core && core.palette && core.palette.neutralLight}`,
        width: '100%',
        margin: '24px 0 16px 0',
      },
      '& span': {
        verticalAlign: 'unset',
      },
      '& .jumbo-card-control-all-btn': {
        color: '#323230',
      },
      '& .alert-info': {
        marginTop: '8px',
      },
      '& .location-target-options label': {
        display: 'inherit',
      },
      '& .intent-target-options label': {
        display: 'inherit',
      },
      '& .intent-target': {
        marginTop: '8px',
      },
      '& .cancel-btn': {
        marginLeft: '8px',
      },
      '& .react-block-ui': {
        '& > div:last-child > div > div': {
          backgroundColor: 'unset',
        },
        '& > div:last-child': {
          alignItems: 'center',
          backgroundColor: 'rgba(256, 256, 256, 0.5)',
          color: core.palette.themePrimary,
          display: 'flex',
          outline: 'none',
          padding: 10,
          '& .blocker-text': {
            fontWeight: 'normal',
            top: '23.5px',
            display: 'inline-block',
            position: 'absolute',
          },
          '& .blocker-image': {
            ...getBlockerStyle(28, core.palette),
            display: 'inline-block',
          },
        },
      },
      '& table tbody .col-sm-9': {
        width: 'unset',
        paddingLeft: 'unset',
      },
      '& .bing-maps-search-box-dropdown li a::after': {
        display: 'none',
      },
      '& .bing-maps-search-box-dropdown li a:focus': {
        outline: '1px solid #605e5c',
      },
      '& table tbody .item-label.schedule-item-label.form-control-static': {
        fontWeight: '600',
        color: '#323130',
        paddingTop: '10px',
        display: 'block',
      },
      '& table tbody .radio .col-sm-3': {
        width: 'unset',
      },
      '& table tbody .radio .col-sm-9': {
        paddingLeft: '8px',
      },
      '& table tbody .col-sm-9 input.k-input.form-control': {
        width: '100px !important',
      },
      '& .adschedule-targets-container .ba-backbone-instance-wrapper .advanced-scheduling-grid .ad-scheduling-panel table tr:nth-child(3) td .radio-inline:nth-child(2)': {
        top: 'unset',
      },
      '& .form-horizontal table tbody .radio': {
        paddingTop: 'unset',
      },
      '& .scheduling-grid .advanced-scheduling-grid': {
        marginTop: '16px',
      },
      '& .hotel-campaign-shared': {
        width: '62.5%',
        minWidth: '968px',
      },
      '& span.error-string': {
        whiteSpace: 'normal',
      },
      '& .hotel-ad-format label': {
        display: 'inherit',
      },
      '& .bid-strategy-options': {
        minHeight: '84px',
        '&  .percentage': {
          position: 'relative',
          minWidth: '296px',
          '& .error-string': {
            position: 'absolute',
            top: '64px',
          },
        },
        '& .disclaimer.has-error': {
          marginTop: '24px',
        },
      },
      '& .campaign': {
        '& .collapse-content.content-show': {
          marginTop: '-4px',
          marginLeft: '-4px',
          '& .campaign-name': {
            marginTop: '4px',
            marginLeft: '4px',
          },
          '& .hotel-ad-format': {
            marginLeft: '4px',
            marginBottom: '4px',
          },
        },
      },
      '& .budget': {
        '& .collapse-content.content-show': {
          marginTop: '-4px',
          marginLeft: '-4px',
          '& .campaign-budget': {
            marginTop: '4px',
            marginLeft: '4px',
            marginBottom: '4px',
          },
        },
      },
      '& span.bold': {
        fontWeight: 1000,
      },
      '& .alert-budget-button': {
        marginLeft: '10px',
        paddingTop: '5px',
        '& button': {
          color: 'black',
          fontSize: '13px',
          fontWeight: 500,
          borderColor: '#edebe9',
        },
      },
    },
    '@global': {
      '.floating-banner.warnFloatingBanner': {
        bottom: 'unset',
        top: '10%',
        background: '#A80000',
        '& .iconba, [role="alert"], [role="button"]': {
          color: 'white',
        },

      },
      '.app-shell .app-content-body div.settings-page': {
        overflow: 'visible',
      },
      '.app-shell .app-content-container-col': {
        backgroundColor: `${core && core.palette && core.palette.neutralLighterAlt}`,
        '& .ba-content-footer, .back-to-campaign': {
          minWidth: '1032px',
        },
      },
      ...spinnerKeyframe,
      ...datePickerStyle(core),
    },
  });
